import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../http";

export type UserInfoInner = {
  full_name: string;
  username: string;
  email: string;
  /**
   * URL to the pfp
   */
  profile_pic: string;
  category: string | null;
  id: string;
  referral_code: string;
  referred_users_count: number;
};

export type UserInfo =
  | {
      state: "logged_in";
      info: UserInfoInner;
    }
  | { state: "logged_out"; info: null };

async function getUserInfo(): Promise<UserInfo> {
  const res = await api.auth.get<UserInfoInner>("users/info", {
    // we're assuming any non-2XX as logged out or unable to be logged in anyways
    // and if it returns 500 we probably have problems everywhere else
    throwHttpErrors: false,
  });
  if (res.status === 200)
    return {
      state: "logged_in",
      info: await res.json(),
    };
  else return { state: "logged_out", info: null };
}

export const userInfoQueryOptions = queryOptions({
  queryKey: ["user", "info"],
  async queryFn() {
    return getUserInfo();
  },
});

export function useUserInfo() {
  return useQuery(userInfoQueryOptions);
}
